  import gsap,{TweenMax} from "gsap";
import SplitText from "../../js/greensock/utils/SplitText";
import when from 'when'
import TensorManager from "@/tensor/tensorManager"
import WebsocketManager from '@/js/websocketManager.js'


export default {
  name: "intro",
  data: () => {
    return {
      nickname: localStorage.nickname ? localStorage.nickname : "",
      agreementActepted: false,
      cameraActepted: false,
      cameraIsLoading: false,
      isSkiped: false,
      isStep2: false,
      isStep3: false,
      isLoaded: false,
      textEnded: false
    }
  },
  mounted() {
    window.addEventListener('keypress', this.validate)

  },
  methods: {
    validate(e) {
      if (e.keyCode === 13) {
        if (this.nickname !== '' && !this.isStep3) {
          let name = this.$refs.login.querySelector("input").value;
          this.$parent.nickname = name
          this.showStep3()
        }
        if (this.cameraActepted && this.isStep3 && !this.isStep4) {
          this.showStep4()
        }
      }
    },
    show() {
      this.$nextTick(() => {
        let titleSplit = new SplitText(this.$refs.title, { type: "chars" }), chars = titleSplit.chars;
        let textSplit = new SplitText(this.$refs.hello, { type: "lines, words, chars", charsClass: 'chars', linesClass: 'lines' }), helloChar = textSplit.chars;
        this.$nextTick(() => {
          // let textSplit = wordSplit.split({ type: "lines" }), lines = textSplit.lines;
          const tl = gsap.timeline();

          tl.fromTo(chars,
            {
              autoAlpha: 0,
              y: 20
            },
            {
              delay: 0.7,
              duration: 1,
              autoAlpha: 1,
              y: 0,
              ease: "power3.inOut",
              stagger: { each: 0.05, ease: "sin.out" },
            },
            "0"
          )

          tl.to(chars,
            {
              delay: 0.5,
              duration: 1.5,
              autoAlpha: 0,
              y: 0,
              ease: "power3.inOut",
              stagger: { each: 0, ease: "sin.out" },
            },
            "2.5"
          )

          tl.fromTo(
            textSplit.lines[0].querySelectorAll('.chars'), { y: 10, opacity: 0 },
            {
              y: 0, opacity: 1, duration: .4, stagger: { each: 0.03 },
            }, "4.15"
          );
          // tl.to(
          //   textSplit.lines[0].querySelectorAll('.chars'),
          //   {
          //     y: 0, opacity: 0, duration: .3
          //   }, '+=2'
          // );

          tl.fromTo(
            textSplit.lines[1].querySelectorAll('.chars'), { y: 10, opacity: 0 },
            {
              y: 0, opacity: 1, duration: .4, stagger: { each: 0.03 },
            }, '+=1'
          );
          // tl.to(
          //   textSplit.lines[1].querySelectorAll('.chars'),
          //   {
          //     y: 0, opacity: 0, duration: .3
          //   }, '+=2'
          // );

          tl.fromTo(
            textSplit.lines[2].querySelectorAll('.chars'), { y: 10, opacity: 0 },
            {
              y: 0, opacity: 1, duration: .4, stagger: { each: 0.03, onComplete: () => {
                setTimeout(() => {
                  if (this.isLoaded) this.showStep2()
                  this.textEnded = true
                }, 1500)
              
              } }, 
            }, '+=1'
          );
          // tl.to(
          //   textSplit.lines[2].querySelectorAll('.chars'),
          //   {
          //     y: 0, opacity: 0, duration: .3, onComplete:  () => {
          //       if (this.isLoaded) this.showStep2()
          //       this.textEnded = true
          //     }
          //   }, '+=2'
          // );


         

          // tl.fromTo(
          //   helloChar, { y: 10, opacity: 0 },
          //   {
          //     y: 0, opacity: 1, duration: .3, stagger: { each: 0.05 },
          //   }, "4.15"
          // );

          tl.to(this.$el.querySelector('.intro-content-hello .sub-hello'), { y: 0, opacity: 1, delay: 2});


          tl.fromTo(
            this.$refs.spinner,
            { autoAlpha: 0 },
            { autoAlpha: 1, duration: 1 },
            "4.5"
          );
        });

      })


    },

    showStep2() {
      document.querySelector(".webgl-main-container").classList.remove("intro")
      this.$parent.glxp.startIntro()
      this.isLoaded = false
      this.isStep2 = true
      TensorManager.loadModels()
      this.fadeOut( this.$el.querySelector('.intro-content-hello'));
      // this.$refs.hello.classList.add('show')
      this.fadeOut(this.$refs.spinner);
      this.fadeIn(this.$refs.login, .8);
      // this.fadeIn(this.$parent.$refs.nav, 3)
      // start after login
      this.$refs.btnStart.addEventListener("click", this.btnStartM);

    },

    showStep3() {
      // animation

      this.isStep3 = true
      this.fadeOut(this.$refs.login, 0);
      this.fadeIn(this.$refs.camera, 1);
      this.fadeIn(this.$refs.skip, 1);
      
    },

    showStep4() {
      // animation
      this.isStep4 = true
      this.fadeOut(this.$refs.camera, 1);
      this.fadeOut(this.$refs.skip, 1);
      this.fadeOut(this.$el, 1)
      setTimeout(() => {
        this.$parent.startWebgl()
    
      }, 1000);
    },

    startCamera() {
      this.$parent.isSound = true
      this.$parent.audio.startAmbiant()
      // this.$parent.setSoundCanvas()
      this.fadeOut(this.$refs.skip);
      this.cameraIsLoading = true
      if(TensorManager.isLoaded) {
        TensorManager.onLoaded()
      } else {  
        TensorManager.on("loaded", () => {
          TensorManager.onLoaded()
        })
      }
    
      if(TensorManager.isReady) {
        TensorManager.activate()
        // TensorManager.desactivate()
        TweenMax.delayedCall(3, () => {
          TensorManager.desactivate()
        })
        TensorManager.on("isWatched", () => {
          this.cameraActepted = true
          this.cameraIsLoading = false
        })
     
      } else {
        TensorManager.on("ready", () => {
          TensorManager.activate()
          // TensorManager.desactivate()
          TweenMax.delayedCall(3, () => {
            TensorManager.desactivate()
          })
          TensorManager.on("isWatched", () => {
            this.cameraActepted = true
            this.cameraIsLoading = false
          })
        
          // setTimeout(() => {
          //   TensorManager.desactivate()
          //   TensorManager.hideFeedBack()
          //   this.cameraActepted = true
          //   this.cameraIsLoading = false
          // }, 1000)
        })
      }
     
    },

    btnStartM() {
      let name = this.$refs.login.querySelector("input").value;
      this.$parent.nickname = name

      localStorage.nickname = this.nickname

      if (name != "" && this.agreementActepted) {
        //save nickname
        this.nickname = name;

        this.showStep3()

      } else {
        if (name == "") {
          this.$refs.login.querySelector("span").innerText = "Please enter a nickname";
        }
        if (this.agreementActepted == false) {
          this.$el.querySelector(".intro-content-login-agreement-wrapper ").classList.add("shake")
          setTimeout(() => { this.$el.querySelector(".intro-content-login-agreement-wrapper ").classList.remove("shake") }, 1000)
        }
      }
    },

    acceptAgreement() {
      this.agreementActepted = !this.agreementActepted
    },

    fadeOut(elem, d = 0) {
      gsap.to(elem, {
        duration: .6,
        delay: d,
        opacity: 0,
        display: "none",
        ease: "power1.out",
      });
    },

    fadeIn(elem, d = 0) {
      gsap.fromTo(
        elem,
        {
          autoAlpha: 0,
          display: "initial",
        },
        {
          autoAlpha: 1,
          duration: 1,
          ease: "power1.out",
          delay: d,
        }
      );
    },

    skipCamera(){
      if(this.isSkiped) return
      this.isSkiped = true
      this.$parent.isSound = true
      this.$parent.audio.startAmbiant()
      // this.$parent.setSoundCanvas()
      this.$parent.skipCam = true;
      TweenMax.delayedCall(7, this.$parent.toggleButtonMode)
      this.$parent.showTuto = true;
      this.showStep4()
    },

    spanify(text, delay) {
      let t = text.split(" ")
      let out = ""
      let tmp = 0
      t.forEach(l => {
        out += ' <span class="word"> '
        let w = l.split("")
        w.forEach(c => {
          if (delay) {
            out += '<span style=" transition-delay:' + tmp * .015 + 's" class="letter">'
            out += c
            out += '</span>'
            tmp++
          } else {
            out += '<span class="letter">'
            out += c
            out += '</span>'
            tmp++
          }
        })
        out += '</span>'
      })
      return out
    },
    nestedLinesSplit(target, vars) {
      var split = new SplitText(target, vars),
        words = (vars.type.indexOf("words") !== -1),
        chars = (vars.type.indexOf("chars") !== -1),
        insertAt = function (a, b, i) { //insert the elements of array "b" into array "a" at index "i"
          var l = b.length,
            j;
          for (j = 0; j < l; j++) {
            a.splice(i++, 0, b[j]);
          }
          return l;
        },
        children, child, i;
      if (typeof (target) === "string") {
        target = document.querySelectorAll(target);
      }
      if (target.length > 1) {
        for (i = 0; i < target.length; i++) {
          split.lines = split.lines.concat(this.nestedLinesSplit(target[i], vars).lines);
        }
        return split;
      }

      //mark all the words and character <div> elements as _protected so that we can identify the non-split stuff.
      children = (words ? split.words : []).concat(chars ? split.chars : []);

      for (i = 0; i < children.length; i++) {
        children[i]._protect = true;
      }

      children = split.lines;
      for (i = 0; i < children.length; i++) {
        child = children[i].firstChild;
        //if the first child isn't protected and it's not a text node, we found a nested element that we must bust up into lines.
        if (!child._protect && child.nodeType !== 3) {
          children[i].parentNode.insertBefore(child, children[i]);
          children[i].parentNode.removeChild(children[i]);
          children.splice(i, 1);
          i += insertAt(children, this.nestedLinesSplit(child, vars).lines, i) - 1;
        }
      }
      return split;
    }
  }
};
